import $ from 'jquery';
import pako from 'pako';

import {ENDERECO_API} from '../../config/constant';
import {decode as base64_decode, encode as base64_encode} from 'base-64';
import {showDuplicateLoginAlert} from '../../components/Auth/DuplicateLoginAlert';

const isAplicativosAuthError = (xhr) => {
  const candidates = [xhr?.message, xhr?.responseText, xhr?.responseJSON];

  return candidates.some((value) => {
    if (value === 'erro_auth') {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    let normalizedValue = value.trim();

    if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
      normalizedValue = JSON.parse(normalizedValue);
    }

    try {
      normalizedValue = base64_decode(normalizedValue);
    } catch (err) {
      return normalizedValue === 'erro_auth';
    }

    return normalizedValue === 'erro_auth';
  });
};

const handleAplicativosError = (xhr, reject, rejectMessage, useResponseText) => {
  if (isAplicativosAuthError(xhr)) {
    showDuplicateLoginAlert();
  }

  const message = useResponseText ? xhr?.responseText : rejectMessage;
  reject([400, {message}]);
};

const ajaxAplicativosEvent = (type, ll, dd, tk, parseType = 'jsonBase64', rejectMessage = 'erro', useResponseText = false, extraData = {}, url = `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`) => new Promise(function (resolve, reject) {
  try {
    $.ajax({
      url,
      type,
      dataType: 'json',
      headers: {
        Authorization: 'Bearer ' + tk,
      },
      data: {
        pp: base64_encode('aplicativos'),
        ll: base64_encode(ll),
        dd,
        tk,
        ...extraData,
      },
      success: async function (data, status, xhr) {
        if (parseType === 'jsonBase64') {
          resolve([200, JSON.parse(base64_decode(data))]);
          return;
        }

        if (parseType === 'base64') {
          resolve([200, base64_decode(data)]);
          return;
        }

        resolve([200, data]);
      },
      error: function (xhr, status, error) {
        handleAplicativosError(xhr, reject, rejectMessage, useResponseText);
      },
    });
  } catch (err) {
    reject([500, {message: 'Server Error'}]);
  }
});

const RestAplicativosGet = (config) => {
  const caminho = config.dest.trim();
  const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
  const storage = JSON.parse(usersRt);
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];
  const dataPostBase = [base64_encode(emp), base64_encode(uid)];

  switch (caminho) {
    case 'cards':
      return ajaxAplicativosEvent('Get', 'cards', base64_encode(JSON.stringify(dataPostBase)), token);
    case 'aplicativos':
      return ajaxAplicativosEvent('Get', 'aplicativos', base64_encode(JSON.stringify(dataPostBase)), token);
    case 'clientesPlanos':
      return ajaxAplicativosEvent('Get', 'clientesPlanos', base64_encode(JSON.stringify(dataPostBase)), token);
    case 'getPlanos':
      return ajaxAplicativosEvent('Get', 'getPlanos', base64_encode(JSON.stringify(dataPostBase)), token, 'jsonBase64', '', true);
    case 'getPlanosLoja_':
      return ajaxAplicativosEvent('GET', 'getPlanosLoja', base64_encode(JSON.stringify(dataPostBase)), token, 'jsonBase64', 'Dados não localizados');
    case 'getPlanosLoja':
      return ajaxAplicativosEvent('Get', 'getPlanosLoja', base64_encode(JSON.stringify(dataPostBase)), token, 'jsonBase64', '', true);
    case 'getClientesPlanos':
      return ajaxAplicativosEvent('Get', 'getClientesPlanos', base64_encode(JSON.stringify(dataPostBase)), token, 'jsonBase64', '', true);
    case 'getAplicativosById':
      return ajaxAplicativosEvent('Get', 'getAplicativosById', base64_encode(JSON.stringify([...dataPostBase, base64_encode(config.cod)])), token, 'base64', '', true);
    case 'getValorUpgradePlano':
      return ajaxAplicativosEvent('Get', 'getValorUpgradePlano', [base64_encode(emp), base64_encode(uid), config.dataPost], token, 'raw', '', true);
    default:
      break;
  }
};

const RestAplicativosPost = (config) => {
  const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
  const storage = JSON.parse(usersRt);
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();

  switch (caminho) {
    case 'dadosDeContratoDemaisApps':
      return ajaxAplicativosEvent('Post', 'dadosDeContratoDemaisApps', [base64_encode(emp), base64_encode(uid), Arr_.dataPost], token, 'base64');
    case 'dadosDeContratoEmpAdicionais':
      return ajaxAplicativosEvent('Post', 'dadosDeContratoEmpAdicionais', base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))])), token, 'base64');
    case 'dadosDeContratoUsersAdicionais':
      return ajaxAplicativosEvent('Post', 'dadosDeContratoUsersAdicionais', base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))])), token, 'base64');
    case 'iniciarTeste':
      return ajaxAplicativosEvent('Get', 'iniciarTeste', base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))])), token, 'base64');
    case 'contratarPlano':
      return ajaxAplicativosEvent('Post', 'contratarPlano', [base64_encode(emp), base64_encode(uid), [...Arr_.dataPost, storage[6]]], token, 'raw', 'erro', false, {stepUpToken: Arr_.stepUpToken ?? ''});
    case 'contratarModuloGestao':
      return ajaxAplicativosEvent('Post', 'contratarModuloGestao', [base64_encode(emp), base64_encode(uid), Arr_.dataPost], token, 'raw', 'erro', false, {stepUpToken: Arr_.stepUpToken ?? ''});
    case 'realizarUpgradePlano':
      return ajaxAplicativosEvent('Post', 'realizarUpgradePlano', [base64_encode(emp), base64_encode(uid), Arr_.dataPost], token, 'raw');
    case 'iniciarTesteGestao':
      return ajaxAplicativosEvent('Post', 'iniciarTesteGestao', base64_encode(JSON.stringify([base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))])), token, 'raw');
    case 'validaCupom':
      return ajaxAplicativosEvent('Post', 'validaCupom', [base64_encode(emp), base64_encode(uid), Arr_.dataPost], token, 'raw');
    default:
      break;
  }
};
export {RestAplicativosGet, RestAplicativosPost};



